import { createSlice } from "@reduxjs/toolkit"

export const DEFAULT_PROPERTY_SEARCH_SETTINGS = {
  department: "residential-sales",
  page: 1,
  radius: "",
  orderby: "date",
  per_page: 13,
  for_sale: true,
  under_offer: false,
  sold: false,
}

const propertySearchSlice = createSlice({
  name: "property-search",
  initialState: {
    data: {},
    settings: DEFAULT_PROPERTY_SEARCH_SETTINGS,
    pgp: "",
  },
  reducers: {
    updateSearchState: (state, action) => {
      state.settings = action.payload
    },
    updatePgpPathState: (state, action) => {
      const value = action.payload
      state.pgp = value
    },
  },
})

export const { updateSearchState, updatePgpPathState } =
  propertySearchSlice.actions
export default propertySearchSlice.reducer
